import React from 'react';

interface XIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const XIcon: React.FC<XIconProps> = ({ className = '', width = 14, height = 13 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 14 13" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M10.59 0.900391H12.49L8.33912 5.64452L13.2222 12.1002H9.3988L6.40414 8.18488L2.97756 12.1002H1.07646L5.51619 7.02584L0.831787 0.900391H4.7523L7.45922 4.47917L10.59 0.900391ZM9.92318 10.963H10.976L4.18025 1.97787H3.0505L9.92318 10.963Z" 
        fill="currentColor"
      />
    </svg>
  );
};

export default XIcon;